import React, { useEffect } from 'react'
import { Box, Container, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons'
import { useTheme } from '@mui/material/styles'
import renderHTML from 'react-render-html'
import Heading from '../modules/Heading'
import Media from '../modules/Media'
import NavLink from '../components/nav/NavLink'
import Linebreak from '../modules/Linebreak'
import Gallery from '../modules/Gallery'
import Feed from '../modules/Feed'
import Instagram from '../modules/Instagram'

function TeamDetails({ data, auxData }) {
    const theme = useTheme()
    const originalArray = [
        {
            label: 'Post: Max Girardo',
            value: 'max-girardo',
        },
        {
            label: 'Post: Cat Bunch',
            value: 'cat-bunch',
        },
        {
            label: 'Post: Marcus Willis',
            value: 'marcus-willis',
        },
        {
            label: 'Post: Davide De Giorgi',
            value: 'davide-de-giorgi',
        },
        {
            label: 'Post: Peter Macalpine',
            value: 'peter-macalpine',
        },
        {
            label: 'Post: Alex Easthope',
            value: 'alex-easthope',
        },
    ]
    const teamArray = originalArray.filter(
        (member) => member.value !== data.slug
    )
    const feedOptions = {
        data: {
            categories: [
                'max-girardo',
                'cat-bunch',
                'marcus-willis',
                'davide-de-giorgi',
                'peter-macalpine',
                'alex-easthope',
                'ryenne-brewer',
                'alex-markham',
            ],
            categoryOptions: {
                selected: teamArray,
            },
            collection: 'curated',
            order: {
                by: 'date_published',
                direction: 'desc',
            },
        },
        module: 'Feed',
        feedType: 'descriptive',
    }
    return (
        <Container
            maxWidth='xl'
            mx='auto'
        >
            <Heading
                options={{
                    alignment: 'center',
                    line: true,
                    text: `Meet ${data.title}`,
                    type: 'h2',
                    variant: 'h2',
                }}
            />
            <Box
                display='flex'
                alignItems='center'
                mt={-4}
                mb={2}
            >
                <Box
                    display='flex'
                    mr={1}
                    color='clay.main'
                >
                    <FontAwesomeIcon icon={faCaretLeft} />
                </Box>
                <NavLink
                    color={theme.palette.clay.main}
                    letterSpacing='1px'
                    fontSize='15px'
                    to='/team'
                >
                    Team
                </NavLink>
            </Box>

            <Media
                options={{
                    media: { set: [data.media.set[0]] },
                    module: 'Media',
                }}
            />
            <Linebreak options={{ align: 'left' }} />
            <Box alignItems='flex-start'>
                <Box
                    width={{ xs: '100%', lg: '33%' }}
                    mt={-7}
                    mr={2}
                    mb={3}
                    sx={{ float: { xs: 'none', lg: 'left' } }}
                >
                    <Gallery
                        options={{
                            teamPortrait: true,
                            numOfColumns: 1,
                            media: { set: [data.media.set[1]] },
                        }}
                    />
                </Box>
                <Typography ml={{ xs: 0, lg: 30 }}>
                    {data.content.description &&
                        renderHTML(data.content.description)}
                </Typography>
            </Box>
            <Heading
                options={{
                    alignment: 'center',
                    line: true,
                    text: 'The Girardo & Co Team',
                    type: 'h2',
                    variant: 'h2',
                }}
            />
            <Box>
                <Feed
                    options={feedOptions}
                    auxData={auxData}
                />
            </Box>
            <Linebreak options={{ align: 'left' }} />
            {/* <Instagram options={{ spacing: 0 }} /> */}
        </Container>
    )
}

export default TeamDetails
